export const environment = {
  production: false,
  dashboard_url: 'https://albawaba-staging-api.vmsgo.com/api/dashboard',
  merchant_url: 'https://albawaba-staging-api.vmsgo.com/api/merchant',
};